import { useEffect } from "react";
import { Routes, Route, Navigate, BrowserRouter, HashRouter, useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import NavBar from "./components/NavBar.jsx";
import Footer from "./components/Footer.jsx";

import Home from "./pages/Home.jsx";
import Discover from "./pages/Discover.jsx";
import VendorPortal from "./pages/VendorPortal.jsx";
import Register from "./pages/Register.jsx";
import Login from "./pages/Login.jsx";
import Account from "./pages/Account.jsx";
import Passes from "./pages/Passes.jsx";
import ProfileManagement from "./pages/ProfileManagement.jsx";
import HowItWorks from "./pages/HowItWorks.jsx";
import AuthCallback from "./pages/AuthCallback.jsx";
import UpdatePassword from "./pages/UpdatePassword.jsx";
import MetaPixelTracker from "./components/MetaPixelTracker.jsx";

import AppShell from "./layout/AppShell.jsx";
import AuthGate from "./components/AuthGate.jsx";

export default function App() {
    const isNative = Capacitor.isNativePlatform();
    const Router = isNative ? HashRouter : BrowserRouter;

    useEffect(() => {
        if (typeof document === "undefined") return undefined;

        document.documentElement.classList.toggle("bbp-native", isNative);
        document.body.classList.toggle("bbp-native", isNative);

        return () => {
            document.documentElement.classList.remove("bbp-native");
            document.body.classList.remove("bbp-native");
        };
    }, [isNative]);

    return (
        <Router>
            {isNative ? <NativeRoutes /> : <WebRoutes />}
        </Router>
    );
}

function WebRoutes() {
    return (
        <>
            <NavBar />
            <MetaPixelTracker />

            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/passes" element={<Passes />} />
                <Route path="/merch" element={<Navigate to="/" replace />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/vendor" element={<VendorPortal />} />
                <Route path="/register" element={<Register />} />
                <Route path="/login" element={<Login />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/profile" element={<ProfileManagement />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
                <Route path="/auth/update-password" element={<UpdatePassword />} />
            </Routes>
            <Footer />
        </>
    );
}

function NativeRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/auth/update-password" element={<UpdatePassword />} />

            <Route
                element={
                    <AuthGate>
                        <AppShell />
                    </AuthGate>
                }
            >
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />
                <Route path="/discover" element={<Discover />} />
                <Route path="/passes" element={<NativePassesRedirect />} />
                <Route path="/my-pass" element={<Passes />} />
                <Route path="/how-it-works" element={<HowItWorks />} />
                <Route path="/vendor" element={<VendorPortal />} />
                <Route path="/account" element={<Account />} />
                <Route path="/account/profile" element={<ProfileManagement />} />
            </Route>

            <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
    );
}

function NativePassesRedirect() {
    const location = useLocation();
    return <Navigate to={`/my-pass${location.search || ""}`} replace />;
}
